import { onMounted, unref } from 'vue'
import { restCursor, changeCursorToResize } from './cursor'
import { setTableColumnsWidth } from '@/utils/store-table-size'
import { debounce } from 'lodash'
const setTableColumnsWidthDebounce = debounce(setTableColumnsWidth, 100)
export default function useResizeColumnsWidth (tableRef, columns, resizeLineVerticalRef, resizeLineVerticalBolderRef, addBodyHoverEventListener, removeBodyHoverEventListener, tableId) {
  let originClientX = 0
  let offestYToTable = 0
  const minWidth = 50
  const maxWidth = 500
  onMounted(() => {
    const table = unref(tableRef)
    table.addEventListener('mousedown', e => {
      const { target } = e
      if (target.className.indexOf && target.className.indexOf('right') >= 0) {
        removeBodyHoverEventListener()
        originClientX = e.clientX
        //
        const targetView = target.getBoundingClientRect()
        const tableView = table.getBoundingClientRect()
        offestYToTable = targetView.left - tableView.left
        resizeLineVerticalRef.value.style.display = 'block'
        resizeLineVerticalRef.value.style.left = `${offestYToTable + 2}px`
        resizeLineVerticalBolderRef.value.style.display = 'block'
        resizeLineVerticalBolderRef.value.style.left = `${offestYToTable}px`
        resizeLineVerticalBolderRef.value.style.top = `${targetView.top - tableView.top}px`
        resizeLineVerticalBolderRef.value.style.height = `${targetView.height}px`
        //
        const fn = mousemoveHandlerForCol(target.parentNode)
        table.addEventListener('mousemove', fn)
        document.addEventListener('mouseup', () => {
          table.removeEventListener('mousemove', fn)
          resizeLineVerticalRef.value.style.display = 'none'
          resizeLineVerticalBolderRef.value.style.display = 'none'
        }, { once: true })
        document.addEventListener('mouseleave', () => {
          table.removeEventListener('mousemove', fn)
          resizeLineVerticalRef.value.style.display = 'none'
          resizeLineVerticalBolderRef.value.style.display = 'none'
        }, { once: true })
        changeCursorToResize('col')
      }
    })
  })

  const mousemoveHandlerForCol = el => {
    return e => {
      const clientX = e.clientX
      const moveDistance = clientX - originClientX
      const index = el.attributes.rightIndex.value
      originClientX = clientX
      const width = el.offsetWidth + moveDistance
      if (width < minWidth || width > maxWidth) {
        return
      }
      columns.value[index] = width
      setTableColumnsWidthDebounce(tableId.value, JSON.stringify(columns.value))
      offestYToTable += moveDistance
      resizeLineVerticalRef.value.style.left = `${offestYToTable + 2}px`
      resizeLineVerticalBolderRef.value.style.left = `${offestYToTable}px`
      restCursor()
    }
  }
}
